import { map } from 'lodash'
import { success, error } from '@/utils/alert'
import moment from 'moment'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM')
  },
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/rollback-from-delayed')
      .then(({data}) => {
        success('Horário(s) foram revertido(s) com sucesso.')
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao definido como agendado.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/active-agenda/components/rollback-from-delayed/resources/methods.js